import styled from 'styled-components'

export const Container = styled.div`
  display: block;
  width: 100%;
  max-width: 31.25rem;
  @media (max-width: 806px) {
    display: none;
  }
`

export const ContainerCard = styled.div`
  width: 100%;
  max-width: 31.25rem;
  border-radius: 15px;
  /* border: 1px solid #b7b7b7; */
  background: #fff;
  padding-bottom: 15px;
  @media (max-width: 806px) {
    height: 280px;
  }
`

export const HeaderContainer = styled.header`
  display: flex;
  justify-content: space-between;
  padding: 30px 30px 0px 30px;
  flex-wrap: wrap;
  @media (max-width: 806px) {
    display: none;
    padding: 15px 15px 0px 15px;
  }
`

export const TitleContainerMobile = styled.div`
  display: none;
  @media (max-width: 806px) {
    display: flex;
    margin-bottom: 1rem;
  }
`

export const TitleContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 5px;
  gap: 20px;
`

export const IconContainer = styled.div`
  margin-top: 8px;
  cursor: pointer;
`

export const TitleTextMobile = styled.h1`
  font-size: 16px;
  font-weight: 600;
`

export const TitleText = styled.h1`
  font-size: 22px;
  font-weight: 500;
`

export const PercentageContainer = styled.div`
  padding: 30px 30px 20px 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  @media (max-width: 806px) {
    padding: 15px 15px 0px 15px;
  }
`

export const PercentageText = styled.h1`
  font-size: 25px;
  font-weight: 700;
`

export const TotalText = styled.h1`
  font-size: 18px;
  font-weight: 500;
  /* color: #1d1d1d; */
`

export const ChartContainer = styled.div`
  padding: 0px 30px 0px 30px;
  @media (max-width: 806px) {
    padding: 0px 15px 0px 15px;
  }
`

export const VisitsSalesContainer = styled.div`
  display: flex;
  padding: 0px 30px 30px 30px;
  gap: 50px;
  @media (max-width: 806px) {
    padding: 0px 15px 15px 15px;
  }
`

export const VisitsContainer = styled.div``

export const VisitsText = styled.h1`
  font-size: 14px;
  font-weight: 400;
  color: #8d8d8d;
  &:before {
    content: '';
    width: 30px;
    height: 4px;
    background-color: #000000;
    margin-bottom: 2px;
    border-radius: 100px;
    margin-right: 15px;
    display: inline-block;
  }
`

export const VisitsNumber = styled.h1`
  font-size: 14px;
  font-weight: 600;
  margin-top: 10px;
  margin-left: 45px;
`

export const SalesContainer = styled.div``

export const SalesText = styled.h1`
  font-size: 14px;
  font-weight: 400;
  color: #8d8d8d;
  &:before {
    content: '';
    width: 30px;
    height: 4px;
    background-color: #32d583;
    margin-bottom: 2px;
    border-radius: 100px;
    margin-right: 15px;
    display: inline-block;
  }
`

export const SalesNumber = styled.h1`
  font-size: 14px;
  font-weight: 600;
  margin-top: 10px;
  margin-left: 45px;
`

export const FooterContainer = styled.div`
  display: flex;
  padding: 30px 30px 30px 30px;
  gap: 22px;
  @media (max-width: 806px) {
    padding: 15px 10px 15px 15px;
  }
`

export const FooterText = styled.p`
  font-size: 14px;
  font-weight: 400;
`

export const ExclamationIconContainer = styled.div``
